// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BotSettings_wrapper__nX-b3 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}
.BotSettings_infos__aEK9U{
  margin: 110px 0px;
  color: orange;
}
.BotSettings_heading__PvOj7 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.BotSettings_label__MdA8y {
  display: block;
  margin-top: 10px;
  font-weight: 500;
  color: #444;
  text-align: left;
}

.BotSettings_input__ioMJ0 {
  display: block;
  width: 100%;
  padding: 12px 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
}

.BotSettings_input__ioMJ0:focus {
  border-color: #007bff;
  outline: none;
}

.BotSettings_textarea__Gk3op {
  display: block;
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
  resize: vertical;
  transition: border-color 0.2s ease;
}

.BotSettings_textarea__Gk3op:focus {
  border-color: #007bff;
  outline: none;
}

.BotSettings_updateBtn__dgpyW{
  padding: 10px 20px;
  background-color: var(--saveBtn);
  color: var(--white-color);
  font-size: 1rem;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-top: 40px;
  align-self: flex-end;
}

.BotSettings_updateBtn__dgpyW:disabled,
.BotSettings_updateBtn__dgpyW.BotSettings_disabled__mEoIP {
  background-color: var(--cancelBtn);
  cursor: not-allowed;
  opacity: 0.7;
  color: var(--heading);
}

.BotSettings_updateBtn__dgpyW:not(:disabled):hover {
  background-color: var(--saveHover);
}

.BotSettings_centered__9oB-A{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 90vh;
}

.BotSettings_wrapper__nX-b3 p {
  text-align: end;
  color: rgb(158, 158, 158);
  font-style: italic;
}

.BotSettings_botContent_wrap__Bj47w {
    width: 100%;
    /* background-color: var(); */
    border-radius: 1px;
    /* padding: 2rem 0rem; */
    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
    height: 100%;
    /* border-radius: 10px; */
    display: flex;
    flex-direction: column;
    min-height: 700px;
}

.BotSettings_title__gxgne {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: var(--dark-color);
  text-align: center;
  letter-spacing: 0.5px;
}

@media (max-width: 480px) {
  .BotSettings_container__Opd5U {
    flex-direction: column;
    padding: 16px;
  }
  .BotSettings_title__gxgne {
    font-size: 1.4rem;
  }
  /* .botContent_wrap{
    padding: 16px;
  } */
    .BotSettings_updateBtn__dgpyW{
    margin-top: 20px;
  }
  .BotSettings_infos__aEK9U{
    margin: 20px auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/LeadGenBotSettings/BotSettings.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;0CACwC;EACxC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,wBAAwB;IACxB,8CAA8C;IAC9C,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;;KAEG;IACD;IACA,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n.infos{\n  margin: 110px 0px;\n  color: orange;\n}\n.heading {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.label {\n  display: block;\n  margin-top: 10px;\n  font-weight: 500;\n  color: #444;\n  text-align: left;\n}\n\n.input {\n  display: block;\n  width: 100%;\n  padding: 12px 8px;\n  margin-top: 5px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 1rem;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease;\n}\n\n.input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.textarea {\n  display: block;\n  width: 100%;\n  padding: 8px;\n  margin-top: 5px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 1rem;\n  resize: vertical;\n  transition: border-color 0.2s ease;\n}\n\n.textarea:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.updateBtn{\n  padding: 10px 20px;\n  background-color: var(--saveBtn);\n  color: var(--white-color);\n  font-size: 1rem;\n  border-radius: 6px;\n  border: none;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  margin-top: 40px;\n  align-self: flex-end;\n}\n\n.updateBtn:disabled,\n.updateBtn.disabled {\n  background-color: var(--cancelBtn);\n  cursor: not-allowed;\n  opacity: 0.7;\n  color: var(--heading);\n}\n\n.updateBtn:not(:disabled):hover {\n  background-color: var(--saveHover);\n}\n\n.centered{\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 90vh;\n}\n\n.wrapper p {\n  text-align: end;\n  color: rgb(158, 158, 158);\n  font-style: italic;\n}\n\n.botContent_wrap {\n    width: 100%;\n    /* background-color: var(); */\n    border-radius: 1px;\n    /* padding: 2rem 0rem; */\n    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */\n    height: 100%;\n    /* border-radius: 10px; */\n    display: flex;\n    flex-direction: column;\n    min-height: 700px;\n}\n\n.title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  color: var(--dark-color);\n  text-align: center;\n  letter-spacing: 0.5px;\n}\n\n@media (max-width: 480px) {\n  .container {\n    flex-direction: column;\n    padding: 16px;\n  }\n  .title {\n    font-size: 1.4rem;\n  }\n  /* .botContent_wrap{\n    padding: 16px;\n  } */\n    .updateBtn{\n    margin-top: 20px;\n  }\n  .infos{\n    margin: 20px auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `BotSettings_wrapper__nX-b3`,
	"infos": `BotSettings_infos__aEK9U`,
	"heading": `BotSettings_heading__PvOj7`,
	"label": `BotSettings_label__MdA8y`,
	"input": `BotSettings_input__ioMJ0`,
	"textarea": `BotSettings_textarea__Gk3op`,
	"updateBtn": `BotSettings_updateBtn__dgpyW`,
	"disabled": `BotSettings_disabled__mEoIP`,
	"centered": `BotSettings_centered__9oB-A`,
	"botContent_wrap": `BotSettings_botContent_wrap__Bj47w`,
	"title": `BotSettings_title__gxgne`,
	"container": `BotSettings_container__Opd5U`
};
export default ___CSS_LOADER_EXPORT___;
